// 首页与导航：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动首页
export const mobile = Object.freeze({
  "mobile.category.all": "全部分類",
  "mobile.category.searchPlaceholder": "請輸入搜索關鍵詞",
  "mobile.home.bulkUploadTitle": "批量上傳供需資料",
  "mobile.home.bulkUploadHint": "支持 XLS、XLSX 檔案，每次上傳一個檔案",
  "mobile.home.uploadAction": "點擊上傳",
  "mobile.home.cancel": "取消",
  "mobile.home.confirm": "確定",
  "mobile.home.bannerAlt": "首頁 Banner",
  "mobile.home.serviceValues": "先搜服務價值",
  "mobile.home.excellentService": "卓越服務",
  "mobile.home.continuousInnovation": "持續創造",
  "mobile.home.winTogether": "協作共贏",
  "mobile.home.sharedValue": "價值共享",
  "mobile.home.content": "首頁內容",
  "mobile.home.feedTabs": "首頁資料分類",
  "mobile.home.viewMode": "商品展示方式",
  "mobile.home.twoColumns": "雙列模式",
  "mobile.home.listMode": "列表模式",
  "mobile.home.listEnd": "我們是有底線的",
  "mobile.home.loadFailedReload": "獲取數據失敗，請重新載入",
  "mobile.home.noProducts": "暫無可展示的商品",
  "mobile.home.filterClues": "篩選供需資料",
  "mobile.home.filterSelectedCount": "篩選供需資料，已選{count}項",
  "mobile.home.clueSearchPlaceholder": "搜索品牌、料號、類型或供應商",
  "mobile.home.clearSearch": "清除搜索關鍵詞",
  "mobile.home.searchClues": "搜索供需資料",
  "mobile.home.import": "導入",
  "mobile.home.filter": "篩選",
  "mobile.home.closeFilter": "關閉篩選",
  "mobile.home.sourceRegion": "貨源地",
  "mobile.home.brand": "品牌",
  "mobile.home.brandInitial": "品",
  "mobile.home.collapse": "收起",
  "mobile.home.expand": "展開",
  "mobile.home.reset": "重置",
  "mobile.home.viewResults": "查看結果",
  "mobile.home.clear": "清除",
  "mobile.home.loadFailedRetry": "獲取數據失敗，請重試",
  "mobile.home.reload": "重新載入",
  "mobile.home.type": "類型",
  "mobile.home.capacity": "容量",
  "mobile.home.architecture": "架構",
  "mobile.home.speed": "速率",
  "mobile.home.ballCount": "球位",
  "mobile.home.quantity": "數量",
  "mobile.home.unitPrice": "單價",
  "mobile.home.priceOnRequest": "價格面議",
  "mobile.home.noPartNumber": "無料號",
  "mobile.home.batch": "批次",
  "mobile.home.stockLocation": "貨所在地",
  "mobile.home.supplier": "供應商",
  "mobile.home.publishedAt": "發佈時間",
  "mobile.home.noClues": "暫無資料",
  "mobile.home.itemsSelected": "項已選擇",
  "mobile.home.delete": "刪除",
  "mobile.home.review": "審核",
  "mobile.home.all": "全部",
  "mobile.home.mainland": "大陸",
  "mobile.home.hongKongMacaoTaiwan": "港澳台",
  "mobile.home.allBrands": "全部品牌",
  "mobile.home.keyword": "關鍵詞",
  "mobile.home.tradeInfo": "成交資料",
  "mobile.home.clueInfo": "供需商機",
  "mobile.home.newOrder": "您有新訂單!",
  "mobile.home.acceptOrder": "去接單",
  "mobile.home.uploading": "上傳中...",
  "mobile.home.uploadSucceeded": "上傳成功",
  "mobile.home.uploadFailed": "上傳失敗",
  "mobile.home.selectUploadFile": "請選擇要上傳的檔案",
  "mobile.home.waitForUpload": "檔案上傳中，請等待上傳完成",
  "mobile.home.importSucceeded": "導入成功",
  "mobile.home.importFailed": "導入失敗",
  "mobile.home.importFailedRetry": "導入失敗，請稍後重試",
  "mobile.home.confirmDeletion": "刪除確認",
  "mobile.home.deleteSelectedConfirm": "是否刪除這{count}條數據？",
  "mobile.home.deleteSucceeded": "刪除成功",
  "mobile.home.deleteFailedRetry": "刪除失敗，請稍後重試",
  "mobile.home.confirmReview": "審核確認",
  "mobile.home.reviewSelectedConfirm": "是否審核這{count}條數據？",
  "mobile.home.reviewSucceeded": "審核成功",
});

// 测试商城首页
export const testHome = Object.freeze({
  "pcCsHome.products": "商品",
  "pcCsHome.information": "資料",
  "pcCsHome.imageView": "圖片視圖",
  "pcCsHome.tableView": "表格視圖",
  "pcCsHome.brandPlaceholder": "請輸入品牌",
  "pcCsHome.partNumberPlaceholder": "請輸入料號",
  "pcCsHome.origin": "貨源地",
  "pcCsHome.originPlaceholder": "請選擇貨源地",
  "pcCsHome.supplierPlaceholder": "請輸入供應商",
  "pcCsHome.productType": "產品類型",
  "pcCsHome.productTypePlaceholder": "請輸入產品類型/容量/架構/速率/球位",
});

// 页脚
export const footer = Object.freeze({
  "pcFooter.logo": "先搜標誌",
  "pcFooter.email": "電子電郵地址",
  "pcFooter.phone": "電話",
  "pcFooter.wechat": "微信",
  "pcFooter.weibo": "微博",
  "pcFooter.taobao": "淘寶",
  "pcFooter.copyright":
    "Copyright © 2017-2026 先搜科技 (https://www.xsou.com) All Rights Reserved.",
  "pcFooter.company": "先搜科技",
  "pcFooter.about": "關於先搜",
  "pcFooter.contact": "聯絡我們",
  "pcFooter.join": "加入我們",
  "pcFooter.privacy": "隱私説明",
  "pcFooter.help": "幫助中心",
  "pcFooter.services": "先搜服務",
  "pcFooter.supplierJoin": "供應商入駐",
  "pcFooter.supplyChainManagement": "供應鏈管理",
  "pcFooter.supplyChainServices": "供應鏈服務",
  "pcFooter.supplyChainFinance": "供應鏈金融",
  "pcFooter.products": "產品介紹",
  "pcFooter.flash": "快閃記憶體",
  "pcFooter.memory": "記憶體",
  "pcFooter.embedded": "嵌入式儲存器",
  "pcFooter.ssd": "固態硬碟",
  "pcFooter.memoryModule": "記憶體模組",
  "pcFooter.usbFlashCard": "USB快閃記憶體卡",
  "pcFooter.gpuServer": "GPU伺服器",
  "pcFooter.chipNetwork": "先搜芯鏈",
  "pcFooter.ai": "先搜AI",
  "pcFooter.featuredChips": "晶片精選",
  "pcFooter.bidding": "晶片競價",
  "pcFooter.supplyDemand": "供需資料",
  "pcFooter.directSales": "晶片自營",
  "pcFooter.wiki": "晶片百科",
  "pcFooter.marketIndex": "價格指數",
  "pcFooter.tools": "工具",
  "pcFooter.ascTool": "ASC工具",
  "pcFooter.xmlTool": "XML工具",
});

// 桌面首页
export const desktop = Object.freeze({
  "pcHome.groupedViewDetail": "查看詳情",
  "pcHome.operation": "操作",
  "pcHome.goReview": "去審核",
  "pcHome.technicalParameters": "技術參數",
  "pcHome.productSpecifications": "產品規格",
  "pcHome.quantityBatch": "數量 / 批次",
  "pcHome.publishInfo": "發佈資訊",
  "pcHome.scrollTableLeft": "向左捲動列表",
  "pcHome.scrollTableRight": "向右捲動列表",
  "pcHome.tableHorizontalScroll": "列表橫向捲動條",
  "pcHome.selectLoadedClues": "全選目前已載入的資訊",
  "pcHome.contactPublisher": "聯絡發佈人 {name}",
  "pcHome.publisherConsultationFailed": "暫時無法開啟發佈人諮詢，請重試",
  "pcHome.marketNav": "行情",
  "pcHome.brandFallback": "品牌{number}",
  "pcHome.sortName": "名稱",
  "pcHome.sortProducts": "產品數",
  "pcHome.sortPopularity": "熱度",
  "pcHome.bulkUploadTitle": "批量上傳供需資料",
  "pcHome.bulkUploadDescription": "請上傳 Excel 檔案，支持 .xlsx、.xls 格式",
  "pcHome.chooseFile": "點擊上傳檔案",
  "pcHome.cancel": "取消",
  "pcHome.confirm": "確定",
  "pcHome.confirmUpload": "確定上傳",
  "pcHome.searchPlaceholder": "搜索料號、名稱",
  "pcHome.searchAction": "先搜一下",
  "pcHome.serviceValues": "先搜服務價值",
  "pcHome.excellentService": "卓越服務",
  "pcHome.continuousInnovation": "持續創造",
  "pcHome.winWinCooperation": "協作共贏",
  "pcHome.sharedValue": "價值共享",
  "pcHome.ai": "先搜AI",
  "pcHome.popularBrands": "熱門品牌",
  "pcHome.moreBrands": "查看更多品牌",
  "pcHome.brandsLoading": "品牌載入中...",
  "pcHome.noBrands": "暫無品牌數據",
  "pcHome.scrollShortcutsLeft": "向左滑動快捷入口",
  "pcHome.scrollShortcutsRight": "向右滑動快捷入口",
  "pcHome.shortcutIcon": "圖標",
  "pcHome.backToTop": "回到頂部",
  "pcHome.shortcut.supplyDemand": "供需",
  "pcHome.shortcut.supply": "供應",
  "pcHome.shortcut.demand": "需求",
  "pcHome.shortcut.selfOperated": "自營",
  "pcHome.shortcut.featured": "精選",
  "pcHome.shortcut.bidding": "競標",
  "pcHome.shortcut.wiki": "晶片百科",
  "pcHome.shortcut.marketIndex": "價格指數",
  "pcHome.shortcut.traceability": "檢測溯源",
  "pcHome.shortcut.training": "培訓認證",
  "pcHome.shortcut.brands": "品牌",
  "pcHome.importSupplyDemand": "導入供需",
  "pcHome.gridView": "圖片",
  "pcHome.cardView": "卡片",
  "pcHome.listView": "列表",
  "pcHome.endOfList": "我們是有底線的",
  "pcHome.loadFailedRetry": "獲取數據失敗，請重新載入",
  "pcHome.image": "圖片",
  "pcHome.productImage": "商品圖片",
  "pcHome.brand": "品牌",
  "pcHome.brandInitial": "品",
  "pcHome.partNumber": "料號",
  "pcHome.noPartNumber": "無料號",
  "pcHome.type": "類型",
  "pcHome.capacity": "容量",
  "pcHome.architecture": "架構",
  "pcHome.speed": "速率",
  "pcHome.ballCount": "球位",
  "pcHome.price": "價格",
  "pcHome.unitPrice": "單價",
  "pcHome.quantity": "數量",
  "pcHome.publisher": "發佈人",
  "pcHome.noData": "暫無數據",
  "pcHome.filters": "篩選條件",
  "pcHome.brandLabel": "品牌：",
  "pcHome.all": "全部",
  "pcHome.search": "搜索",
  "pcHome.originLabel": "貨源地：",
  "pcHome.mainland": "大陸",
  "pcHome.hongKongMacaoTaiwan": "港澳台",
  "pcHome.keywordLabel": "關鍵詞：",
  "pcHome.filterPlaceholder":
    "搜索品牌、料號、產品類型、容量、架構、速率、球位、供應商或發佈人",
  "pcHome.reset": "重置",
  "pcHome.query": "查詢",
  "pcHome.loading": "載入中...",
  "pcHome.loadFailedRefresh": "獲取數據失敗，請刷新重試",
  "pcHome.reload": "重新載入",
  "pcHome.batch": "批次",
  "pcHome.goodsLocation": "貨所在地",
  "pcHome.publishedAt": "發佈時間",
  "pcHome.supplier": "供應商",
  "pcHome.selectedCount": "已選擇 {count} 項",
  "pcHome.delete": "刪除",
  "pcHome.review": "審核",
  "pcHome.searchBrand": "搜索品牌",
  "pcHome.brandNamePlaceholder": "請輸入品牌名稱",
  "pcHome.searching": "搜索中...",
  "pcHome.noMatchingBrands": "未找到匹配的品牌",
  "pcHome.informationSaved": "儲存成功，待審核",
  "pcHome.information": "資訊信息",
  "mobile.home.information": "資訊信息",
  "pcHome.tradeInfo": "成交資料",
  "pcHome.supplyDemandInfo": "供需商機",
  "pcHome.newMessages": "您有新訊息!",
  "pcHome.viewMessages": "去查看",
  "pcHome.newOrders": "您有新訂單!",
  "pcHome.acceptOrder": "去接單",
  "pcHome.uploading": "上傳中...",
  "pcHome.uploadSuccess": "上傳成功",
  "pcHome.uploadFailed": "上傳失敗",
  "pcHome.chooseFileFirst": "請選擇要上傳的檔案",
  "pcHome.waitForUpload": "檔案上傳中，請等待上傳完成",
  "pcHome.importSuccess": "導入成功",
  "pcHome.importFailed": "導入失敗",
  "pcHome.deleteConfirmTitle": "刪除確認",
  "pcHome.deleteConfirmMessage": "是否刪除這{count}條數據？",
  "pcHome.deleteSuccess": "刪除成功",
  "pcHome.deleteFailed": "刪除失敗，請稍後重試",
  "pcHome.reviewConfirmTitle": "審核確認",
  "pcHome.reviewConfirmMessage": "是否審核這{count}條數據？",
  "pcHome.reviewSuccess": "審核成功",
});

export const messages = Object.freeze({
  ...mobile,
  ...testHome,
  ...footer,
  ...desktop,
});
